import { AbiFunction } from 'ox';
import { htlcFunctions } from '../../abi.js';
import { hex } from '../../utils.js';
export function buildRedeemSolverTx(params) {
    const data = AbiFunction.encodeData(htlcFunctions.redeemSolver, [
        hex(params.id),
        1n,
        BigInt(params.secret),
    ]);
    return { to: params.contractAddress, data };
}
